module.exports = __webpack_public_path__ + "static/04-a1fa5ba23ab51c1d23cd54f5d03ceb09.jpg";